import { motion } from "framer-motion";
import { BEFORE_AFTER, SUCCESS_METRICS } from "@/data/content";
import Testimonials from "@/components/sections/Testimonials";
import HonestyBlock from "@/components/sections/HonestyBlock";
import CTASection from "@/components/sections/CTASection";

export default function SuccessPage() {
  return (
    <div data-testid="success-page" className="pt-32 sm:pt-40">
      <section className="px-5 sm:px-6 lg:px-12 pb-12 sm:pb-16">
        <div className="max-w-[1400px] mx-auto">
          <p className="overline">Success</p>
          <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-[8rem] leading-[0.95] tracking-tight mt-5 sm:mt-6 max-w-[14ch]">
            Real businesses.
            <br />
            <span className="italic text-aurora">Honest changes.</span>
          </h1>
          <p className="text-base sm:text-lg text-neutral-700 max-w-2xl mt-8 sm:mt-10 leading-relaxed">
            We publish qualitative before-and-after stories rather than
            invented dollar figures. Real numbers - and what they cost - are
            shared transparently on a discovery call.
          </p>
        </div>
      </section>

      <section className="px-5 sm:px-6 lg:px-12 py-12 sm:py-16 border-y border-neutral-200">
        <div className="max-w-[1400px] mx-auto grid grid-cols-2 md:grid-cols-4 gap-y-8 gap-x-6">
          {SUCCESS_METRICS.map((s) => (
            <div key={s.label} data-testid={`success-stat-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <div className="font-serif italic text-4xl sm:text-5xl md:text-6xl text-gold leading-none">
                {s.value}
              </div>
              <div className="text-[10px] sm:text-xs uppercase tracking-[0.18em] text-neutral-600 mt-3 sm:mt-4">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="px-5 sm:px-6 lg:px-12 py-16 sm:py-24">
        <div className="max-w-[1400px] mx-auto space-y-12 sm:space-y-16">
          {BEFORE_AFTER.map((c, i) => (
            <motion.article
              key={c.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8 }}
              data-testid={`success-case-${c.id}`}
              className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12"
            >
              <div className="lg:col-span-4">
                <p className="overline">{c.sector}</p>
                <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.05] mt-4 sm:mt-6">
                  {c.title}
                </h2>
              </div>
              <div className="lg:col-span-7 lg:col-start-6 grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-6">
                <div className="border border-neutral-200 bg-white p-6 sm:p-8">
                  <p className="overline">Before</p>
                  <p className="text-neutral-600 mt-3 sm:mt-4 leading-relaxed text-sm sm:text-base">
                    {c.before}
                  </p>
                </div>
                <div className="border border-gold/30 bg-gold/[0.04] p-6 sm:p-8">
                  <p className="overline">After · GoldKey Studio</p>
                  <p className="text-neutral-900 mt-3 sm:mt-4 leading-relaxed text-sm sm:text-base">
                    {c.after}
                  </p>
                </div>
                <p className="sm:col-span-2 text-xs text-neutral-400 italic leading-relaxed">
                  {c.note}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </section>

      <Testimonials />
      <HonestyBlock />
      <CTASection />
    </div>
  );
}
